export * from './baCompanyPicture.pipe';



// WEBPACK FOOTER //
// ./src/app/theme/pipes/baCompanyPicture/index.ts